<template>
    <div class="panel panel-default">
        <div class="panel-heading">
            <h3>Поиск авто</h3>
        </div>
        <div class="panel-body-filters">
            <div class="title">Параметры</div>
            <div style="clear: both"></div>
            <div class="filters" id="filter-form">
                <div class="cos-form-5">
                    <div class="form-group select-data input-daterange"
                         data-provide="datepicker">
                        <date-picker
                                id="completed_from"
                                name="completed_from"
                                class="form-control"
                                placeholder="Дата от"
                                v-model="q_search.completed_from"
                                @keypress.enter="search(q_search)"
                        ></date-picker><date-picker
                                id="completed_to"
                                name="completed_to"
                                class="form-control"
                                placeholder="до"
                                v-model="q_search.completed_to"
                                @keypress.enter="search(q_search)"
                        ></date-picker>
                    </div>
                    <div class="form-group">
                        <select class="form-control" name="year" v-model="q_list.year"
                                :class="filterDirtyClass('year')"
                                @change="search(q_search)">
                            <option value="" selected="selected">Год производства</option>
                            <option v-for="year in years" :value="year">{{ year }}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <input class="form-control select-field" type="text" name="user" value=""
                               v-model="q_search.client"
                               @keypress.enter="search(q_search)" placeholder="Клиент">
                    </div>
                </div>
                <div class="cos-form-5">
                    <div class="form-group">
                        <input class="form-control select-field" type="text" name="state_number" value=""
                               v-model="q_search.state_number"
                               @keypress.enter="search(q_search)" placeholder="Гос. номер">
                    </div>
                    <div class="form-group select-data">
                        <input class="form-control select-field mileage_from" type="text" name="km_age_from" value=""
                               v-model="q_search.mileage_from" @keypress.enter="search(q_search)"
                               placeholder="Пробег с"><input class="form-control select-field mileage_to"
                                                             type="text"
                                                             name="km_age_to"
                                                             value=""
                                                             v-model="q_search.mileage_to"
                                                             @keypress.enter="search(q_search)"
                                                             placeholder="по">
                    </div>
                    <div class="form-group">
                        <input class="form-control select-field" type="text" name="phone" value=""
                               v-model="q_search.phone"
                               @keypress.enter="search(q_search)" placeholder="Телефон">
                    </div>
                </div>
                <div class="cos-form-5">
                    <div class="form-group">
                        <select class="form-control" name="brand" v-model="q_list.brand"
                                :class="filterDirtyClass('brand')"
                                @change="search(q_search)">
                            <option value="" selected="selected">Марка</option>
                            <option v-for="brand in brands" :value="brand">{{ brand }}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <select class="form-control" name="transmission" v-model="q_list.transmission"
                                :class="filterDirtyClass('transmission')"
                                @change="search(q_search)">
                            <option value="" selected="selected">Трансмиссия</option>
                            <option v-for="transmission in transmissions" :value="transmission">{{ transmission }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <input class="form-control select-field" type="text" name="name" v-model="q_search.user_fio"
                               @keypress.enter="search(q_search)" placeholder="ФИО исполнителя">
                    </div>
                </div>
                <div class="cos-form-5">
                    <div class="form-group">
                        <select class="form-control" name="model" v-model="q_list.model"
                                :class="filterDirtyClass('model')"
                                @change="search(q_search)">
                            <option value="" selected="selected">Модель</option>
                            <option v-for="model in models" :value="model">{{ model }}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <select class="form-control" name="engine" v-model="q_list.engine"
                                :class="filterDirtyClass('engine')"
                                @change="search(q_search)">
                            <option value="" selected="selected">Тип двигателя</option>
                            <option v-for="engine in engines" :value="engine">{{ engine }}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <input class="form-control select-field" type="text" name="salon" v-model="q_search.salon_name"
                               @keypress.enter="search(q_search)" placeholder="Автосалон">
                    </div>
                </div>
                <div class="cos-form-5">


                    <!--<div class="form-group">
                        <input class="form-control select-field" type="text" name="number" value=""
                               placeholder="Номер оценки">
                    </div>-->

                    <div class="form-group">
                        <input class="form-control select-field" type="text" name="vin" value=""
                               v-model="q_search.vin" @keypress.enter="search(q_search)" placeholder="VIN номер">
                    </div>
                    <!--<div class="form-group">
                        <select class="form-control" name="country" v-model="q_list.country"
                                :class="filterDirtyClass('country')">
                            <option value="" selected="selected">Страна производитель</option>
                            <option v-for="country in countries" :value="country">{{ country }}</option>
                        </select>
                    </div>-->
                </div>
            </div>
        </div>
        <table class="table table-striped">
            <thead>
            <tr>
                <th>Автомобиль</th>
                <th>Гос. номер</th>
                <th>VIN Номер</th>
                <th>Заполнено</th>
                <th>Пользователь</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="inspection in inspections">
                <td>
                    <a :href="`/inspections/${inspection.id}`">{{ inspection.brand.name }} {{ inspection.model.name
                        }}</a>
                </td>
                <td>{{ inspection.state_number }}</td>
                <td>{{ inspection.vin_number }}</td>
                <td>{{ inspection.completed_at | date_format('DD.MM.YYYY HH:mm') }}</td>
                <td>
                    <a :href="`/users/${inspection.user_id}`">{{ inspection.user.full_name }}</a>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import axios from 'axios'
    import _ from 'lodash'

    export default {
        data() {
            return {
                q_search: {
                    user_fio: '',
                    salon_name: '',
                    vin: '',
                    state_number: '',
                    client: '',
                    phone: '',
                    mileage_from: '',
                    mileage_to: '',
                    completed_from: '',
                    completed_to: '',
                },
                q_list: this.freshFilters(),
                filters: this.freshFilters(),
                countries: [],
                brands: [],
                models: [],
                years: [],
                transmissions: [],
                engines: []
            }
        },
        props: {
            'salon_id': {}
        },
        asyncComputed: {
            inspections() {
                return axios
                    .get('/api/inspections', {
                        params: {
                            q_search: {
                                user_fio: this.q_search.user_fio,
                                salon_name: this.q_search.salon_name,
                                vin: this.q_search.vin,
                                state_number: this.q_search.state_number,
                                client: this.q_search.client,
                                phone: this.q_search.phone,
                                mileage_from: this.q_search.mileage_from,
                                mileage_to: this.q_search.mileage_to,
                                completed_from: this.q_search.completed_from,
                                completed_to: this.q_search.completed_to,
                            },
                            q_list: this.q_list,
                            salon_id: this.salon_id
                        }
                    })
                    .then(({data}) => {
                        //this.countries = data.filters.countries
                        this.brands = data.filters.brands
                        this.models = data.filters.models
                        this.years = data.filters.years
                        this.transmissions = data.filters.transmissions
                        this.engines = data.filters.engines

                        return data.inspections.data
                    })
            },
        },
        methods: {
            search(q_search) {
                if (q_search.type == 'keypress') q_search.preventDefault()

                this.refreshBrandsModels()

                axios
                    .get('/api/inspections', {
                        params: {
                            q_search,
                            q_list: this.q_list,
                            limit: 5,
                            salon_id
                        }
                    })
                    .then(response => {
                        //this.countries = response.data.filters.countries
                        this.brands = response.data.filters.brands
                        this.models = response.data.filters.models
                        this.years = response.data.filters.years
                        this.transmissions = response.data.filters.transmissions
                        this.engines = response.data.filters.engines

                        this.inspections = response.data.inspections.data
                    })
            },
            freshFilters() {
                return {
                    year: '',
                    country: '',
                    status: '',
                    completed_from: '',
                    completed_to: '',
                    brand: '',
                    transmission: '',
                    model: '',
                    engine: ''
                }
            },
            filterDirtyClass(field) {
                return {'filter-dirty': ('' !== this.q_list[field])}
            },
            refreshBrandsModels() {
                if (this.q_list.brand !== this.filters.brand) {
                    this.q_list.model = ''
                    this.q_list.year = ''
                    this.q_list.transmission = ''
                    this.q_list.engine = ''
                }
                if (this.q_list.model !== this.filters.model) {
                    this.q_list.year = ''
                    this.q_list.transmission = ''
                    this.q_list.engine = ''
                }
                Object.assign(this.filters, this.q_list)

            },
        },
        mounted() {
            this.$on('change_completed_from', function (completed_from) {
                if (this.q_search.completed_from != completed_from)
                    this.q_search.completed_from = completed_from
            })
            this.$on('change_completed_to', function (completed_to) {
                if (this.q_search.completed_to != completed_to)
                    this.q_search.completed_to = completed_to
            })
        }
    }
</script>

<style lang="less">
    @import "../../less/_boot";

    .cos-form-5 {
        box-sizing: border-box;
        width: 19.5%;
        display: block;
        float: left;
        margin-left: 0.5%;
    }

    .cos-form-5:first-child {
        margin-left: 0;
    }

    .cos-form-5 select {
        color: #999999;
    }

    #completed_from, .select-data .mileage_from {
        width: 50%;
        display: inline-block;
        border-right: none;
    }

    #completed_to, .select-data .mileage_to {
        width: 50%;
        display: inline-block;
        border-left: none;
    }
</style>



// WEBPACK FOOTER //
// SearchCarSupervisor.vue?03112116